import React from 'react';
import {useRef} from 'react';
import * as api from '../../api';
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { ValidateEventDates } from '../../utils/ValidateEvent';
import CustomEditor from '../TextEditor/CustomEditor';

const FDCreateEventAdminPanel = (props) => {

    const navigate = useNavigate();
    const [searchparams] = useSearchParams();
    const title_fr_ref = useRef(null);
    // const description_fr_ref = useRef(null);
    // const description_en_ref = useRef(null);
    const inscriptions_start_date_ref = useRef(null);
    const inscriptions_end_date_ref = useRef(null);
    const logo_path_ref = useRef(null);
    const image_path_ref = useRef(null);

    const [descFR, setDescFR] = React.useState("")
    const [descEN, setDescEN] = React.useState("")

    async function handlePublish() {
        console.log('trying to publish');

        const newEvent = new FormData();
        newEvent.append("type", searchparams.get("type"));
        newEvent.append("title_fr", title_fr_ref.current.value);
        // newEvent.append("description_fr", description_fr_ref.current.value);
        // newEvent.append("description_en", description_en_ref.current.value);
        newEvent.append("description_fr", descFR);
        newEvent.append("description_en", descEN);
        newEvent.append("inscriptions_start_date", inscriptions_start_date_ref.current.value);
        newEvent.append("inscriptions_end_date", inscriptions_end_date_ref.current.value);
        newEvent.append("logo_path", logo_path_ref.current.files[0]);
        newEvent.append("image_path", image_path_ref.current.files[0]);

        if(!ValidateEventDates({type:searchparams.get("type"),inscriptions_start_date:inscriptions_start_date_ref.current.value,inscriptions_end_date:inscriptions_end_date_ref.current.value})){
            alert("Dates invalides")
            return
        }

        api.createEvent(newEvent).then(res => {
            console.log(res);
            navigate("/admin/events")
        }).catch(err => {
            console.log(err);
            alert("erreur");
        });
    }

    return (
        <div>
            <Link to="/admin/events"><button>← Retour aux événements</button></Link><br/><br/>
            <br/>
            <h1 className='centered'>Créer un événement {searchparams.get("type")}</h1>
            <br/>
            <div className='dualInput'>
                <label>
                    Nom de l'appel à projet :<br/>
                    <input required type="text" ref={title_fr_ref} />
                </label>
            </div>
            Description FR :<br/><br/>
            <CustomEditor 
                value={descFR}
                onChange={setDescFR}
            />
            <br/><br/>
            Description EN :<br/><br/>
            <CustomEditor 
                value={descEN}
                onChange={setDescEN}
            />
            <br/><br/>
            <div className='dualInput'>
                <label>
                    Date de début des inscriptions :<br/>
                    <input required type="date" ref={inscriptions_start_date_ref} />
                </label>
                <label>
                    Date de fin des inscriptions :<br/>
                    <input required type="date" ref={inscriptions_end_date_ref} />
                </label>
            </div>
            <div className='dualInput'>
                <label>
                    Logo (obligatoire) :<br/>
                    <input required type="file" ref={logo_path_ref} />
                </label>
                <label>
                    Visuel (obligatoire) :<br/>
                    <input required type="file" ref={image_path_ref} />
                </label>
            </div>
            <br/>
            <button className='centered' onClick={handlePublish}>Enregistrer</button>
            <br/>
            <p className='centered'>Vous devez d'abord enregistrer l'événement pouvoir le prévisualiser</p>
        </div>
    );
};


export default FDCreateEventAdminPanel;